export type AccentColor = {
    Id: number | string;
    Name: string;
    LightHex: string;
    DarkHex: string;
};

export type AccentColorShades = Pick<AccentColor, "LightHex" | "DarkHex">;

const FALLBACK_LIGHT = "#e9d5ff";
const FALLBACK_DARK = "#4c1d95";
const FALLBACK_TEXT_LIGHT = "#7c3aed";
const FALLBACK_TEXT_DARK = "#c4b5fd";

/** Background shade for the active theme. */
export function resolveAccentBackground(
    color: AccentColorShades | null | undefined,
    mode: string | undefined,
): string {
    if (!color) {
        return mode === "dark" ? FALLBACK_DARK : FALLBACK_LIGHT;
    }
    return mode === "dark" ? color.DarkHex || FALLBACK_DARK : color.LightHex || FALLBACK_LIGHT;
}

/** Contrasting text/border shade for the active theme. */
export function resolveAccentForeground(
    color: AccentColorShades | null | undefined,
    mode: string | undefined,
): string {
    if (!color) {
        return mode === "dark" ? FALLBACK_TEXT_DARK : FALLBACK_TEXT_LIGHT;
    }
    return mode === "dark" ? color.LightHex || FALLBACK_TEXT_DARK : color.DarkHex || FALLBACK_TEXT_LIGHT;
}

export function findAccentByName(
    colors: AccentColor[] | null | undefined,
    name: string | null | undefined,
): AccentColor | undefined {
    if (!colors?.length || !name) return undefined;
    const key = String(name).trim().toLowerCase();
    return colors.find((c) => c.Name?.trim().toLowerCase() === key);
}

export function resolveEventAccent(
    colors: AccentColor[] | null | undefined,
    colorName: string | null | undefined,
    mode: string | undefined,
): { background: string; foreground: string; color?: AccentColor } {
    const color = findAccentByName(colors, colorName);
    return {
        color,
        background: resolveAccentBackground(color, mode),
        foreground: resolveAccentForeground(color, mode),
    };
}
